import { useEffect, createContext, useReducer, useContext } from 'react';

import { User, Team, Trophy, Tournament } from '../../types';

type State = {
    trophies: Trophy[],
    teams: Team[],
    tournaments: Tournament[],
    friends: User[],
    isLoading: boolean,
    error: any,
} | {};

type Action = {
    type: string,
    prop?: string,
    data: State | Trophy[] | Team[] | Tournament[] | User[],
};

type Reducer = (state: State, action?: Action) => State;

type Provider = {
    children: React.ReactElement,
};

export const RegistrationContext = createContext(null);
export const RegistrationDispatchContext = createContext(null);

export function RegistrationProvider({children, registrations: data}): React.ReactElement<Provider> {
    const [registrations, dispatch] = useReducer(
        registrationReducer,
        data,
    );

    return (
        <RegistrationContext.Provider value={registrations}>
            <RegistrationDispatchContext.Provider value={dispatch}>
                {children}
            </RegistrationDispatchContext.Provider>
        </RegistrationContext.Provider>
    );
}

export function useRegistration() {
    return useContext(RegistrationContext);
}

export function useRegistrationDispatch() {
    return useContext(RegistrationDispatchContext);
}

function registrationReducer(state: State, action: Action): State {
    switch (action.type) {
        case 'update-prop': {
            const newState = { ...state };
            newState[action.prop] = action.data;
            return newState;
        }
        case 'update': {
            return { ...state, ...action.data };
        }
        case 'replace': {
            return action.data;
        }
    }
}
